<template>
  <div class="text-xs-center">
    <template v-if="selectedBot && selectedBot.type !== 'gpf' && selectedBot.theme !== 'webchat'">
      <v-layout>
        <template
          v-if="
            !['universalutilities', 'hafele', 'scgallrent', 'nvbb'].includes(selectedBot.theme) &&
            !['102052945584054', '106855151601601', '100707492390105'].includes(livechat.pageid)
          "
        >
          <v-flex
            v-if="selectedBot.theme != 'scgworkplace' && !isGpfBuddy"
            style="position: relative"
          >
            <v-btn
              depressed
              style="border-radius: 0; width: 100%"
              class="ma-0"
              :color="$store.state.livechat.app == 'facebook' ? 'primary' : 'grey'"
              @click="changeApp('facebook')"
              dark
            >
              <em class="fab fa-facebook" />
            </v-btn>
            <div class="newnotifycount" v-if="facebooknotify && isTicketAdmin">
              {{ numberFormat(facebooknotify) }}
            </div>
          </v-flex>
        </template>
        <v-flex
          v-if="
            !['universalutilities'].includes(selectedBot.theme) &&
            !['dtac-gaming'].includes(selectedBot.type)
          "
          style="position: relative"
        >
          <v-btn
            depressed
            style="border-radius: 0; width: 100%"
            class="ma-0 pa-0"
            :color="$store.state.livechat.app == 'line' ? 'primary' : 'grey'"
            @click="changeApp('line')"
            dark
          >
            <em class="fab fa-line" />
          </v-btn>
          <div class="newnotifycount" v-if="linenotify && isTicketAdmin">
            <span v-if="selectedBot.pageid == '100207768987988'">{{
              numberFormat(newchatnotify.line_admin)
            }}</span>
            <span v-else>{{ numberFormat(linenotify) }}</span>
          </div>
        </v-flex>
        <v-flex>
          <v-btn
            depressed
            style="border-radius: 0; width: 100%; position: relative"
            class="ma-0 pa-0 py-3"
            @click="$emit('onsearch', true)"
          >
            <v-icon>search</v-icon>
            <!-- <v-btn
              v-if="input.search && selectedBot.theme == 'scgworkplace'"
              icon
              @click.stop="clearSearch"
              small
              style="position: absolute; right: 0; margin: 0"
            >
              <span style="font-size: 18px" class="material-icons">clear</span>
            </v-btn> -->
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout wrap>
        <v-flex xs10>
          <v-layout wrap>
            <v-flex :xs3="['gpf'].includes(selectedBot.type)" style="position: relative">
              <v-btn
                icon
                style="border-radius: 0; width: 100%"
                class="ma-0"
                :color="$store.state.livechat.app == 'facebook' ? 'primary' : 'grey'"
                @click="changeApp('facebook')"
                dark
              >
                <em class="fab fa-facebook" />
              </v-btn>
              <div class="newnotifycount" v-if="facebooknotify && isTicketAdmin">
                {{ numberFormat(facebooknotify) }}
              </div>
            </v-flex>
            <v-flex :xs3="['gpf'].includes(selectedBot.type)" style="position: relative">
              <v-btn
                icon
                style="border-radius: 0; width: 100%"
                class="ma-0 pa-0"
                :color="$store.state.livechat.app == 'line' ? 'primary' : 'grey'"
                @click="changeApp('line')"
                dark
              >
                <em class="fab fa-line" />
              </v-btn>
              <div class="newnotifycount" v-if="linenotify && isTicketAdmin">
                <span v-if="selectedBot.pageid == '100207768987988'">{{
                  numberFormat(newchatnotify.line_admin)
                }}</span>
                <span v-else>{{ numberFormat(linenotify) }}</span>
              </div>
            </v-flex>
            <v-flex :xs3="['gpf'].includes(selectedBot.type)" style="position: relative">
              <v-btn
                icon
                style="border-radius: 0; width: 100%"
                class="ma-0 pa-0"
                :color="$store.state.livechat.app == 'webchat' ? 'primary' : 'grey'"
                @click="changeApp('webchat')"
                dark
              >
                <em class="fas fa-globe" />
              </v-btn>
              <div class="newnotifycount" v-if="webchatnotify && isTicketAdmin">
                {{ numberFormat(webchatnotify) }}
              </div>
            </v-flex>
            <v-flex
              :xs3="['gpf'].includes(selectedBot.type)"
              style="position: relative"
              v-if="['gpf'].includes(selectedBot.type)"
            >
              <v-btn
                icon
                block
                style="border-radius: 0; width: 100%"
                class="ma-0 pa-0"
                :color="$store.state.livechat.app == 'app' ? 'primary' : 'grey'"
                @click="changeApp('app')"
                dark
              >
                <em class="fas fa-mobile-alt" />
              </v-btn>
              <div class="newnotifycount" v-if="appnotify && isTicketAdmin">
                {{ numberFormat(appnotify) }}
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs2 style="position: relative">
          <v-btn
            icon
            style="border-radius: 0; position: relative; width: 100%"
            class="ma-0 pa-0 py-3"
            @click="$emit('onsearch', true)"
          >
            <v-icon>search</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <div style="position: relative">
      <template v-if="currentLivechatExpireTime > 0">
        <div class="px-1 info caption white--text">
          แพคเกจรวมแชทคงเหลือ
          <countdown :time="currentLivechatExpireTime * 1000">
            <template slot-scope="props">
              <template v-if="props.days">
                {{ props.days | numberFormat }}
                <span class="small">{{ $t('Days') }}</span>
              </template>
              <template v-else-if="props.hours > 0">
                {{ props.hours | numberFormat }}
                <span class="small">{{ $t('Hours') }}</span>
              </template>
              <template v-else-if="props.minutes > 0">
                {{ props.minutes | numberFormat }}
                <span class="small">{{ $t('Minutes') }}</span>
              </template>
              <template v-else>
                {{ props.seconds | numberFormat }}
                <span class="small">{{ $t('Seconds') }}</span>
              </template>
            </template>
          </countdown>
        </div>
      </template>
      <v-layout>
        <v-flex>
          <v-tabs
            id="usertype"
            color="grey lighten-3"
            :value="$store.state.livechat.type"
            :slider-color="$vuetify.theme.primary"
            @change="changeType"
          >
            <v-tab ripple :key="'admin'" :href="'#admin'" style="position: relative">
              <div>
                {{ $t('Admin') }}
                <div
                  class="newnotifycount"
                  v-if="chatnotify && chatnotify.admin && chatnotify.admin != '0' && isTicketAdmin"
                >
                  {{ numberFormat(chatnotify.admin) }}
                </div>
              </div>
            </v-tab>
            <v-tab ripple :key="'bot'" :href="'#bot'" style="position: relative">
              <div>
                {{ $t('chatbot') }}
                <div
                  class="newnotifycount"
                  v-if="
                    chatnotify &&
                    chatnotify.bot &&
                    chatnotify.bot != '0' &&
                    isTicketAdmin &&
                    selectedBot.pageid != '100207768987988'
                  "
                >
                  {{ numberFormat(chatnotify.bot) }}
                </div>
              </div>
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex shrink>
          <div style="background-color: #eeeeee">
            <!-- <v-btn icon @click="showSetting = true">
              <v-icon>settings</v-icon>
            </v-btn> -->
            <cooldown :delay="10" cname="refresh_chat_user" @onLoad="onRefreshChatUser">
              <template v-slot="{ zloading, onClick, show }">
                <v-btn v-if="show" icon @click="onClick" :loading="zloading">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </template>
              <template v-slot:countdown="{ show, delaytime, onCountdownEnd }">
                <template v-if="show && delaytime !== true && delaytime > 0">
                  <v-btn v-if="show" icon :loading="true">
                    <v-icon>refresh</v-icon>
                    <countdown :time="delaytime * 1000" @end="onCountdownEnd"> </countdown>
                  </v-btn>
                </template>
              </template>
            </cooldown>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog v-model="showSetting" scrollable persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-spacer /><v-btn icon small @click="showSetting = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text v-if="showSetting">
          <LineQuota></LineQuota>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Cooldown from '@/components/elements/Cooldown'
import LineQuota from './LineQuota'
import { PAGE } from '@/constants/page.js'

export default {
  props: ['newchatnotify'],
  components: {
    Cooldown,
    LineQuota
  },
  data() {
    return {
      showSetting: false
    }
  },
  mounted() {},
  computed: {
    test() {
      return this.$store.state.privilege.view_ticket
    },
    isTicketAdmin() {
      if (
        this.selectedBot.theme == 'ticket' ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
      ) {
        if (
          this.selectedBot.pageid == '102549712095297' ||
          this.selectedBot.pageid == '105387828535129'
        ) {
          return true
        }
        return (
          !this.$store.state.privilege.view_ticket ||
          this.$store.state.privilege.view_ticket == 'all'
        )
      } else return true
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      livechat: 'livechat'
    }),
    currentLivechatExpireTime() {
      var bot = this.botlist.find((el) => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (bot && bot.livechat_expireat != null) {
        var now = moment()
        var date = moment(bot.livechat_expireat)
        return parseInt(now.diff(date, 'seconds'))
      } else return null
    },
    chatnotify() {
      if (this.$store.state.livechat.app == 'facebook')
        return {
          admin: this.newchatnotify.facebook_admin,
          bot: this.newchatnotify.facebook_bot
        }
      else if (this.$store.state.livechat.app == 'line')
        return {
          admin: this.newchatnotify.line_admin,
          bot: this.newchatnotify.line_bot
        }
    },
    facebooknotify() {
      if (this.newchatnotify.facebook_bot || this.newchatnotify.facebook_admin) {
        return (
          parseFloat(this.newchatnotify.facebook_bot) +
          parseFloat(this.newchatnotify.facebook_admin)
        )
      } else return ''
    },
    linenotify() {
      if (this.newchatnotify.line_bot || this.newchatnotify.line_admin) {
        return parseFloat(this.newchatnotify.line_bot) + parseFloat(this.newchatnotify.line_admin)
      } else return ''
    },
    webchatnotify() {
      if (this.newchatnotify.webchat_bot || this.newchatnotify.webchat_admin) {
        return (
          parseFloat(this.newchatnotify.webchat_bot) + parseFloat(this.newchatnotify.webchat_admin)
        )
      } else return ''
    },
    appnotify() {
      if (this.newchatnotify.app_bot || this.newchatnotify.app_admin) {
        return parseFloat(this.newchatnotify.app_bot) + parseFloat(this.newchatnotify.app_admin)
      } else return ''
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    }
  },
  methods: {
    changeApp(type) {
      this.$store.commit('SET_LIVECHAT_APP', type)
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    changeType(name) {
      this.$store.commit('SET_LIVECHAT_TYPE', name)
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    onRefreshChatUser(payload) {
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
      if (payload) payload.callback()
    },
    updateRoute: function () {
      var query = { ...this.$route.query }
      query.app = this.app
      query.user = this.type

      this.$router.push({
        name: 'allinonechat',
        path: '/allinonechat',
        query: query
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatTab.vue